// extracted by mini-css-extract-plugin
module.exports = {"fullScreenModal":"_2OdAn"};